// removed by extract-text-webpack-plugin
module.exports = {"FavIndicator":"FavIndicator__FavIndicator__-hash-base-64-5-","FavIndicatorActive":"FavIndicator__FavIndicatorActive__-hash-base-64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/containers/BeerDetails/FavIndicator/FavIndicator.scss
// module id = 190
// module chunks = 0